import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  addBrandAPI,
  deleteBrandAPI,
  fetchBrandsAPI,
  getBrandDetailsAPI,
  syncBrandAPI,
  updateBrandAPI,
  uploadImageAPI,
} from '../apis/hyperwolfBrand';

export const fetchBrands = createAsyncThunk(
  'hyperwolfBrand/fetchBrands',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchBrandsAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createBrand = createAsyncThunk(
  'hyperwolfBrand/createBrand',
  async (data, { rejectWithValue }) => {
    try {
      const res = await addBrandAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const uploadBrandImage = createAsyncThunk(
  'hyperwolfBrand/uploadBrandImage',
  async (data, { rejectWithValue }) => {
    try {
      const res = await uploadImageAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getBrandDetails = createAsyncThunk(
  'hyperwolfBrand/getBrandDetails',
  async (brandId, { rejectWithValue }) => {
    try {
      const res = await getBrandDetailsAPI(brandId);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateBrand = createAsyncThunk(
  'hyperwolfBrand/updateBrand',
  async ({ brandId, data }, { rejectWithValue }) => {
    try {
      const res = await updateBrandAPI(brandId, data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteBrand = createAsyncThunk(
  'hyperwolfBrand/deleteBrand',
  async (brandId, { rejectWithValue }) => {
    try {
      const res = await deleteBrandAPI(brandId);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const syncBrand = createAsyncThunk(
  'hyperwolfBrand/syncBrand',
  async (_, { rejectWithValue }) => {
    try {
      const res = await syncBrandAPI();
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  isLoading: false,
  isUploading: false,
  isFetchingDetails: false,
  isDeleting: false,
  syncBrandLoader: false,
  error: null,
  brandsList: [],
  total: 0,
  brandDetails: null,
};

const hyperwolfBrandSlice = createSlice({
  name: 'hyperwolfBrand',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrands.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.isLoading = false;
        const payload = action.payload ?? {};
        state.brandsList = payload?.data ?? [];
        state.total = payload?.total ?? 0;
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createBrand.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createBrand.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createBrand.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(uploadBrandImage.pending, (state) => {
        state.isUploading = true;
      })
      .addCase(uploadBrandImage.fulfilled, (state) => {
        state.isUploading = false;
      })
      .addCase(uploadBrandImage.rejected, (state) => {
        state.isUploading = false;
      })
      .addCase(getBrandDetails.pending, (state) => {
        state.isFetchingDetails = true;
        state.brandDetails = null;
      })
      .addCase(getBrandDetails.fulfilled, (state, action) => {
        state.isFetchingDetails = false;
        const payload = action.payload ?? {};
        state.brandDetails =
          payload.brand ?? payload.data ?? payload;
      })
      .addCase(getBrandDetails.rejected, (state, action) => {
        state.isFetchingDetails = false;
        state.brandDetails = null;
        state.error = action.payload;
      })
      .addCase(updateBrand.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateBrand.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateBrand.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteBrand.pending, (state) => {
        state.isDeleting = true;
      })
      .addCase(deleteBrand.fulfilled, (state) => {
        state.isDeleting = false;
      })
      .addCase(deleteBrand.rejected, (state, action) => {
        state.isDeleting = false;
        state.error = action.payload;
      })
      .addCase(syncBrand.pending, (state) => {
        state.syncBrandLoader = true;
      })
      .addCase(syncBrand.fulfilled, (state) => {
        state.syncBrandLoader = false;
      })
      .addCase(syncBrand.rejected, (state, action) => {
        state.syncBrandLoader = false;
        state.error = action.payload;
      });
  },
});

export default hyperwolfBrandSlice.reducer;
